// extracted by mini-css-extract-plugin
export var dividerLine = "_4g-0";
export var errorBackground = "_4g-1";